// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const GithubDesktopIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <rect
      width={22}
      height={22}
      x={1}
      y={1}
      fill="url(#githubDesktop_svga)"
      rx={6}
    />
    <path
      fill="#F7F8FA"
      d="M12 4.2a8 8 0 0 0-2.53 15.59c.4.08.54-.17.54-.39v-1.36c-2.23.49-2.7-1.07-2.7-1.07-.36-.92-.89-1.17-.89-1.17-.72-.5.06-.48.06-.48.8.05 1.22.82 1.22.82.72 1.22 1.87.87 2.33.66.07-.51.28-.87.5-1.07-1.77-.2-3.63-.88-3.63-3.95q.02-1.32.82-2.15c-.1-.2-.36-1.01.07-2.12 0 0 .67-.2 2.2.82a8 8 0 0 1 4 0c1.52-1.03 2.19-.82 2.19-.82.43 1.1.16 1.92.08 2.12.5.56.82 1.28.82 2.15 0 3.07-1.87 3.75-3.65 3.95.28.24.54.73.54 1.48l-.01 2.19c0 .2.14.46.55.38A8 8 0 0 0 12 4.2"
    />
    <defs>
      <linearGradient
        id="githubDesktop_svga"
        x1={12}
        x2={12}
        y1={1}
        y2={23}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8F32AD" />
        <stop offset={1} stopColor="#5D2B8D" />
      </linearGradient>
    </defs>
  </svg>,
  "GithubDesktop",
);
export default GithubDesktopIcon;
